import DelegationSetting from '@/models/DelegationSetting/DelegationSetting';

export default class DelegationSettingFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.delegateFrom = '';
		this.delegateTo = '';
		this.periodFromFrom = '';
		this.periodFromTo = '';
		this.periodToFrom = '';
		this.periodToTo = '';
		this.isAllTime = false;
		this.remarksMultiple = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			delegateFrom : '0',
			delegateTo : '0',
			periodFromFrom : '0',
			periodFromTo : '0',
			periodToFrom : '0',
			periodToTo : '0',
			isAllTime : '0',
			remarksMultiple : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}